import bookingQuotes from './booking-quotes'
import customer from './customer'
import source from './source'
import channelId from './channel'

import type {
  ModelType
} from 'customer-flows/utils/quote/models'

export const modelRegistry = {
  bookingQuotes,
  customer,
  source,
  channelId
} as const satisfies Record<string, ModelType>
